export default {
    book_now: 'Louer dès maintenant',
    minimum_age: 'Plus de {age} ans uniquement',
    excess_liability: 'Assurance responsabilité',
    security_deposit: 'Dépôt de garantie',
    fuel_policy: 'Politique de carburant',
    like_for_like: 'Réservoir similaire',
    full_to_full: 'Réservoir plein',
    miles_per_rental: '{mileage} miles gratuits par location',
    km_per_rental: '{mileage} kms gratuits par location',
    unlimited_mileage: 'Millage illimité',
    unlimited_mileage_km: 'Kilométrage illimité',
    non_amendable: 'Non modifiable',
    non_refundable: 'Non remboursable',
    free_cancellation_until: 'Annulation gratuite jusqu\'au',
    cancellation_in_line_with: 'Annulation sujette aux',
    tcs: 'Conditions d\'utilisation',
    free_extras_on_collection: 'Deux suppléments gratuits à la récupération',
    glass_and_tyres_covered: 'Vitres et pneus couverts',
    number_of_passengers: 'Nombre de passagers',
    number_of_bags: 'Nombre de bagages',
    fuel_type: 'Type de carburant',
    co2: 'CO2',
    aircon: 'Climatisation',
    transmission: 'Transmission',
    book_type: 'Louer {type}',
    debit_card_deposit: 'Carte de débit acceptée pour la caution',
}



// WEBPACK FOOTER //
// ./node_modules/greenmotion-shared/lang/fr/quotes/price_card.js